import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { adminActions } from "../../../redux/actions";
import { Beat } from "../../../redux/reducers/spinner";
import moment from "moment";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
} from "mdbreact";

function ReviewKYCModal() {
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [kycStatus, setKycStatus] = useState("");

  const { singleVerification, updating, allVerificationLevel } = useSelector(
    (state) => state.admin
  );
  console.log("allVerificationLevel", allVerificationLevel);

  const [payLoad] = useState({
    end_date: new Date(),
    pagination: 0,
  });

  const [data, setData] = useState({
    user_id: "",
    comment: "",
    level_id: "",
  });

  useEffect(() => {
    dispatch(adminActions.filterHumanVerificationLevel(payLoad));
  }, [dispatch, payLoad]);

  function handleClose() {
    setIsOpen(false);
  }

  const handleChange = (event) => {
    const { name, value } = event.target;
    setData((data) => ({ ...data, [name]: value }));
  };

  const handleSubmit = async (event) => {
    console.log("");
    event.preventDefault();
    setSubmitted(true);
    if (kycStatus === "accepted" && data?.comment) {
      try {
        const response = await dispatch(
          adminActions.verifyHumanVerification({
            user_id: singleVerification?.user_id,
            comment: data?.comment,
            level_id: data?.level_id,
          })
        );
        if (response?.status === "success") {
          handleClose();
          dispatch(
            adminActions.showAHumanVerification(singleVerification?.user_id)
          );
        } else {
          console.error("Verification failed:", response);
        }
      } catch (error) {
        console.error("Error verifying human verification:", error);
      }
    } else if (kycStatus === "rejected" && data?.comment) {
      try {
        const response = await dispatch(
          adminActions.rejectHumanVerification({
            user_id: singleVerification?.user_id,
            comment: data?.comment,
          })
        );
        if (response?.status === "success") {
          handleClose();
          dispatch(
            adminActions.showAHumanVerification(singleVerification?.user_id)
          );
        } else {
          console.error("Rejection failed:", response);
        }
      } catch (error) {
        console.error("Error rejecting human verification:", error);
      }
    }
  };

  return (
    <div>
      <MDBContainer>
        <MDBBtn color="primary" onClick={() => setIsOpen(true)}>
          Review Status
        </MDBBtn>
        <MDBModal
          isOpen={isOpen}
          toggle={handleClose}
          size="lg"
          scrollable={"true"}
        >
          <MDBModalHeader toggle={handleClose}> KYC Entries</MDBModalHeader>
          <MDBModalBody>
            <form name="form" onSubmit={handleSubmit}>
              <div className="text-left row px-4">
                {/* KYC Status review from courier app */}
                <form name="form">
                  <div>
                    {/* User details */}
                    <div className="mt-3 shadow-sm px-4 pb-8 rounded-md">
                      <div className="border-b-2 py-2 border-[#EAEAEA]">
                        <h3 className="text-left font-medium text-lg">
                          User Details
                        </h3>
                      </div>

                      <div className="flex justify-between items-center py-2">
                        <span>Full Name:</span>
                        <span className="font-bold text-[#4D4D4D] dark:text-[#BCBCBC]">
                          {singleVerification?.user?.name}
                        </span>
                      </div>
                      <div className="flex justify-between items-center py-2">
                        <span>Email:</span>
                        <span className="font-bold text-[#4D4D4D] dark:text-[#BCBCBC]">
                          {singleVerification?.user?.email}
                        </span>
                      </div>
                      <div className="flex justify-between items-center py-2">
                        <span>Phone Number:</span>
                        <span className="font-bold text-[#4D4D4D] dark:text-[#BCBCBC]">
                          {singleVerification?.user?.phone}
                        </span>
                      </div>
                      <div className="flex justify-between items-center py-2">
                        <span>Date Created:</span>
                        <span className="font-bold text-[#4D4D4D] dark:text-[#BCBCBC]">
                          {moment(singleVerification?.user?.created_at).format(
                            "MMM DD, YYYY"
                          )}
                        </span>
                      </div>
                      <div className="flex justify-between items-center py-2">
                        <span>Country</span>
                        <span className="font-bold text-[#4D4D4D] dark:text-[#BCBCBC]">
                          {singleVerification?.user?.country}
                        </span>
                      </div>
                      <div className="flex justify-between items-center py-2">
                        <span>State:</span>
                        <span className="font-bold text-[#4D4D4D] dark:text-[#BCBCBC]">
                          {singleVerification?.user?.state}
                        </span>
                      </div>
                      <div className="flex justify-between items-center py-2">
                        <span>City:</span>
                        <span className="font-bold text-[#4D4D4D] dark:text-[#BCBCBC]">
                          {singleVerification?.user?.city}
                        </span>
                      </div>
                    </div>

                    {/* KYC Details */}
                    <div className="mt-3 sm:mt-8 shadow-sm px-4 pb-8 rounded-md">
                      <div className="border-b-2 py-2 border-[#EAEAEA]">
                        <h3 className="text-left font-medium text-lg">
                          KYC Details
                        </h3>
                      </div>

                      <div className="flex justify-between items-center py-2">
                        <span>KYC Document:</span>
                        <span className="font-bold text-[#4D4D4D] dark:text-[#BCBCBC]">
                          {singleVerification?.document_type}
                        </span>
                      </div>

                      <div className="flex justify-between items-center py-2">
                        <span>License No:</span>
                        <span className="font-bold text-[#4D4D4D] dark:text-[#BCBCBC]">
                          {singleVerification?.document_number}
                        </span>
                      </div>

                      <div className="mt-5 sm:mt-5 shadow-sm px-4 rounded-md">
                        <div className="border-b-2 py-2 border-[#EAEAEA]">
                          <h3 className="text-left font-medium text-lg">
                            Identity Card (Images)
                          </h3>
                        </div>

                        <div className="row align-items-center py-2">
                          {singleVerification?.documents?.length > 0 &&
                            singleVerification?.documents?.map(
                              (picture, index) => (
                                <div
                                  key={index}
                                  className="col-3"
                                  style={{ margin: "0.375rem" }}
                                >
                                  <img
                                    src={picture}
                                    // src={picture ? picture : EmptyState}
                                    alt="user_picture"
                                    className="img-fluid"
                                    style={{
                                      height: "94px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                              )
                            )}
                        </div>
                        {/* <div className="grid grid-cols-4 gap-3 items-center py-2">
                          {singleVerification?.documents?.length > 0 &&
                            singleVerification?.documents?.map(
                              (image, index) => (
                                <img
                                  key={index}
                                  src={image}
                                  // src={image ? image : EmptyState}
                                  alt="document"
                                  className="h-[94px] h-[94px] object-cover"
                                />
                              )
                            )}
                        </div> */}
                      </div>

                      <div className="mt-5 sm:mt-5 shadow-sm px-4 rounded-md">
                        <div className="border-b-2 py-2 border-[#EAEAEA]">
                          <h3 className="text-left font-medium text-lg">
                            Proof Of Life (Images)
                          </h3>
                        </div>

                        <div className="row align-items-center py-2">
                          {singleVerification?.pictures?.length > 0 &&
                            singleVerification?.pictures?.map(
                              (picture, index) => (
                                <div
                                  key={index}
                                  className="col-3"
                                  style={{ margin: "0.375rem" }}
                                >
                                  <img
                                    src={picture}
                                    // src={picture ? picture : EmptyState}
                                    alt="user_picture"
                                    className="img-fluid"
                                    style={{
                                      height: "94px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                              )
                            )}
                        </div>
                      </div>
                    </div>

                    {/* KYC Status */}
                    <div className="mt-3 sm:mt-8 shadow-sm px-4 py-4 rounded-md text-left">
                      <div className="border-b-2 py-2 border-[#EAEAEA] mb-6">
                        <h3 className="text-left font-medium text-lg">
                          KYC Status
                        </h3>
                      </div>

                      <div className={"form-group col-md-12 mb-4"}>
                        <label htmlFor="status">KYC Status</label>
                        <select
                          htmlFor="status"
                          className="form-control"
                          name="status"
                          onChange={(e) => setKycStatus(e.target.value)}
                        >
                          <option>Select kyc status for this user</option>
                          <option value={"accepted"}>Accepted</option>
                          <option value={"rejected"}>Rejected</option>
                        </select>
                      </div>

                      {kycStatus === "accepted" && (
                        <div className={"form-group col-md-12 mb-4"}>
                          <label htmlFor="level_id">KYC Tier</label>
                          <select
                            name="level_id"
                            htmlFor="level_id"
                            className="form-control"
                            value={data?.level_id}
                            onChange={handleChange}
                          >
                            <option>Select kyc status for this user</option>
                            {allVerificationLevel?.data?.length > 0 &&
                              allVerificationLevel?.data?.map(
                                (level, index) => (
                                  <option value={level?.id} key={index}>
                                    {level?.title}
                                  </option>
                                )
                              )}
                          </select>
                        </div>
                      )}

                      <div className={"form-group col-md-12 mb-4"}>
                        <label htmlFor="comment">
                          Reviewers comment *(comment is required)
                        </label>
                        <textarea
                          name="comment"
                          htmlFor={"comment"}
                          className="form-control"
                          value={data?.comment}
                          defaultValue={singleVerification?.comment}
                          onChange={handleChange}
                          placeholder={
                            "What led to the verification of this user? Pick one comment below."
                          }
                        />
                        {submitted && !data?.comment && (
                          <div className="text-primary text-xs mb-4">
                            Reviewers comment is required
                          </div>
                        )}
                      </div>

                      {/* KYC comment samples */}
                      <div
                        className="d-flex flex-wrap mt-2 mb-3"
                        style={{ gap: "0.375rem" }}
                      >
                        {[
                          "Your KYC was approved",
                          "Your documents are not complete",
                          "Your KYC was rejected",
                          "Unable to verify documents",
                          "Your KYC is pending",
                        ].map((comment, index) => (
                          <MDBBtn
                            key={index}
                            color="light"
                            className="custom-comment-btn px-2 py-1"
                            onClick={() => {
                              if (data?.comment !== comment) {
                                setData((prevData) => ({
                                  ...prevData,
                                  comment,
                                }));
                              }
                            }}
                          >
                            {comment}
                          </MDBBtn>
                        ))}
                      </div>
                    </div>

                    <div className="d-flex mt-4 justify-center mb-4">
                      <MDBBtn
                        color="primary"
                        type="button"
                        disabled={updating}
                        onClick={(e) => handleSubmit(e)}
                      >
                        {updating ? <Beat /> : "Save Changes"}
                      </MDBBtn>
                    </div>
                  </div>
                </form>
              </div>
            </form>
          </MDBModalBody>
        </MDBModal>
      </MDBContainer>
    </div>
  );
}

export default ReviewKYCModal;
